<template>
	<marketing-page-layout
		v-if="appManifestStruct"
		class="landing-layout"
	>
		<div 
			class="hero-container"
		>
			<div 
				class="hero"
			>
				{{ heroText }}
			</div>
			<div 
				class="sub-hero"
			>
				{{ heroSubText }}
			</div>
		</div>
		<marketing-waitlist-cta
			class="marketing-cta"
		>
		</marketing-waitlist-cta>
		<div v-if="firstSingletonTemplate" class="theater">
			<img 
				class="theater-image" 
				:src="firstSingletonTemplate.assets[0].src" 
				:title="firstSingletonTemplate.title"
			/>
			<div class="theater-text">
				<div class="theater-bottom-large">
					<h3 class="large-heading">Visor users have discovered hundreds of use cases.&nbsp;</h3>
					<h3 class="large-heading heading-grey">Discover yours.</h3>
				</div>
				<div class="text-lead">
					Our simplified integration experience empowers anyone to work confidently with live-syncing data from numerous data sources.&nbsp;The lightning-fast updates and rich collaboration make everyone feel closer together, even when they are physically apart.&nbsp; 
				</div>
			</div>
		</div>
		<div 
			class="app-hero"
			:style="{
				'background-color': appManifestStruct && ConnectedAppManifest.apps[appManifestStruct.key] && ConnectedAppManifest.apps[appManifestStruct.key].styles.brandDarkBackground,
			}"
		>			
			<img 
				v-if="appManifestStruct && ConnectedAppManifest.apps[appManifestStruct.key]"
				:src="ConnectedAppManifest.apps[appManifestStruct.key].styles.largeLogoDarkBackground" 
				class="hero-app-logo-img" 
				:title="appManifestStruct.label"
			/>
			<img 
				v-else-if="matchingComingSoonApp"
				:src="matchingComingSoonApp.logo" 
				class="hero-app-logo-img" 
				:title="matchingComingSoonApp.label"
			/>
		</div>
		<div 
			class="use-cases"
		>
			<div 
				v-for="useCase, useCaseIndex in useCasesForApp"
				:key="useCase.key"
				class="use-case-group"
			>
				<div
					class="use-case-tiles"
				>
					<router-link
						v-for="template, templateIndex in useCase.templates" 
						:key="template.key"
						:to="`/templates/spotlight/${template.key}`"
						class="use-case-tile"
						:class="{
							[useCase.colorTheme ? useCase.colorTheme.primary : 'other']: true,
						}"
					>
						<div 
							class="tile-top-bar"
							:style="{
								'background-color': ConnectedAppManifest.apps[appName].styles.brandColor
							}"
						></div>
						<div class="use-case-tile-title">
							{{template.title}}
						</div>
						<div class="app-icons">
							<div 
								v-for="app, appIndex in template.apps"
								:key="app"
								class="app-icon"
								
							>
								<router-link
									:to="`/templates/apps/${app}`"
									class="link"
								>
									<r-tip-simple
										position="top"
										:text="ConnectedAppManifest.apps[app].label"
										class="hover-tip"
									>
										<r-standard-icon
											:icon="ConnectedAppManifest.apps[app].icon.legacyValue"
										></r-standard-icon>
									</r-tip-simple>
								</router-link>
							</div>
						</div>
						<div class="tile-number">
							{{template.count || '100+'}}
						</div>
					</router-link>
				</div>
				<div 
					class="group-expansion"
					@click="toggleSeeMore"
				>
					{{ (showUseCases > 0 ? 'See more' : 'See less') }}
				</div>
			</div>
		</div>
		<marketing-waitlist-cta
			class="marketing-cta"
		>
		</marketing-waitlist-cta>
	</marketing-page-layout>
	<marketing-page-layout
		v-else
	>
		<div class="main-title">
			Sorry, that integration couldn't be found: [{{appName}}]
		</div>
	</marketing-page-layout>
</template>

<script>
	
	import MarketingPageLayout from 'vue/marketing/marketing-page-layout.vue';
	import MarketingWaitlistCta from 'vue/marketing/marketing-waitlist-cta.vue';

	import ConnectedAppManifest from 'js/connected-apps/connected-app-manifest';
	import {useCases, roles, supportedApps, templates} from 'js/marketing/templates/template-manifest.js';

	const DEFAULT_SHOW_USE_CASES = 6;
	const OVERRIDE_TEMPLATES_BY_APP = {
		salesforce: 'bulk-reassign-salesforce-contacts',
	};

	export default {
		$pubsub:{
			
		},
		components:{
			MarketingPageLayout,
			MarketingWaitlistCta,
		},
		data(){
			return {
				showUseCases: DEFAULT_SHOW_USE_CASES,
			};
		},
		props:{
			appName:{
				required: true,
				type: String,
			},
		},
		created(){

		},
		mounted(){

		},
		watch:{
			pageTitle:{
				immediate: true,
				handler(pageTitle){
					if(pageTitle && pageTitle.length > 0){
						document.title = pageTitle;
					}
				}
			}
		},
		computed:{
			ConnectedAppManifest(){
				return ConnectedAppManifest;
			},
			appManifestStruct(){
				const vcSelf = this;
				if(supportedApps){
					return supportedApps.find(function matches(struct){
						return struct.key === vcSelf.appName;
					}) || null;
				}
			},
			useCasesForApp(){
				let retGroups = [];

				if(this.appManifestStruct){
					const groupDetails = Object.assign({
						templates: [],
					}, this.appManifestStruct);					

					for(let template of templates){
						const valueArray = template.apps;

						if(valueArray && valueArray.includes(this.appManifestStruct.key)){
							groupDetails.templates.push(template);
						}

						if(this.showUseCases > 0 && groupDetails.templates.length >= this.showUseCases){
							break;
						}
					}

					retGroups.push(groupDetails);
				}

				return retGroups;
			},
			firstTemplate(){
				if(this.useCasesForApp[0].templates){
					return this.useCasesForApp[0].templates[0];
				}
				return null;
			},
			firstSingletonTemplate(){
				if(this.useCasesForApp[0].templates){
					if(OVERRIDE_TEMPLATES_BY_APP[this.appName]){
						for(let templateIndex in this.useCasesForApp[0].templates){
							if(this.useCasesForApp[0].templates[templateIndex].key === OVERRIDE_TEMPLATES_BY_APP[this.appName]){
								return this.useCasesForApp[0].templates[templateIndex];
							}
						}
					}

					for(let templateIndex in this.useCasesForApp[0].templates){

						if(this.useCasesForApp[0].templates[templateIndex].apps.length === 1){
							return this.useCasesForApp[0].templates[templateIndex];
						}
					}

					// otherwise just return the first one that has it.
					return this.useCasesForApp[0].templates[0];
				}
				return null;
			},
			heroText(){
				// return 'Work like a rogue without being one'
				return `Are you frustrated working with ${this.appManifestStruct.label} data?`;
			},
			heroSubText(){
				return `Get live ${this.appManifestStruct.label} data in a spreadsheet, so you can work your way and stay connected with the team.`;
			},
			pageTitle(){
				if(this.appManifestStruct){
					return `${this.appManifestStruct.label} + Visor`;
				}
				else{
					return 'Visor Integrations';
				}
			},
		},
		methods:{
			toggleSeeMore(){
				if(this.showUseCases > 0){
					this.showUseCases = -1;
				}
				else{
					this.showUseCases = DEFAULT_SHOW_USE_CASES;
				}
			}
		},
	}

</script>

<style lang="scss" scoped>

	.app-hero{
		width: 100%;
		background: $p-color-white;
		color: $p-color-white;
		height: 240px;
		box-sizing: border-box;
		padding: 48px;
		border-radius: 12px;


		font-size: 88px;
		line-height: 102px;
		font-weight: 700;
		letter-spacing: -0.02em;

		text-align: center;
		margin: auto;
		margin-top: 60px;

		display: flex;
		align-items: center;
		justify-content: center;

		background-image: url(../../src/assets/design/organic-shapes/blobs.svg), linear-gradient(-303deg, rgb(0, 0, 0, 0.2), rgb(255, 255, 255, 0.1));
		background-position: center;
		background-repeat: no-repeat;
		background-size: auto 130%;
		
		.hero-app-logo-img{
			height: 99px;
			max-width: 80%;
		}		
	}

	.hero-container{
		margin-top: 120px;
		margin-bottom: 90px;

		.hero{
			font-size: 88px;
			line-height: 88px;
			font-weight: 700;
			letter-spacing: -0.02em;

			text-align: center;
			max-width: 940px;
			margin: auto;
			margin-bottom: 36px;

			@media screen and (max-width: 600px){
				font-size: 48px;
				line-height: 60px;
			}
		}

		.sub-hero{
			color: $p-color-grey-400;
			font-size: 32px;
			line-height: 40px;
			font-weight: 600;
			letter-spacing: -0.02em;

			text-align: center;
			padding-top: 20px;

			max-width: 940px;
			margin: auto;

			@media screen and (max-width: 600px){
				font-size: 24px;
				line-height: 30px;
			}
		}
	}

	.marketing-cta{
		margin-bottom: 90px;
	}

	.link{
		cursor: pointer;
		color: $p-color-grey-300;

		&:hover{
			text-decoration: underline;
			color: $p-color-blue-300;
		}
	}

	.theater{
		max-width: 100%;
		margin-bottom: 90px;

		.theater-image{
			max-width: 100%;
			border-radius: 12px;
		}

		.theater-text{
			box-sizing: border-box;
			max-width: 940px;
			margin-top: 50px;
			margin-left: 12px;

			.theater-bottom-large{
				box-sizing: border-box;
				margin-top: 15px;
				margin-bottom: 20px;

				.large-heading{
					display: inline;
					color: $p-color-white;
					font-size: 40px;
					line-height: 44px;
					font-weight: 600;
					letter-spacing: -0.02em;
					margin-bottom: 0px;

					@media screen and (max-width: 600px){
						font-size: 32px;
						line-height: 40px;
					}

					&.heading-grey{
						color: $p-color-grey-400;
					}
				}
			}

			.text-lead{
				font-family: Inter, sans-serif;
				font-size: 20px;
				line-height: 28px;
				font-weight: 500;
				letter-spacing: 0em;

				@media screen and (max-width: 600px){
					font-size: 16px;
					line-height: 20px;
				}
			}
		}
	}

	.use-cases{		

		.use-case-group{
			padding-bottom: 56px;

			.use-case-group-title{				
				font-size: 36px;
				font-style: normal;
				font-weight: 600;
				line-height: 36px;
				letter-spacing: 0.15px;
				text-align: center;
				margin-bottom: 39px;
			}

			.use-case-group-title-experiment{

				display: block;
				text-decoration: none;

				width: 100%;
				min-height: 120px;
				text-align: left;
				box-sizing: border-box;
				padding: 24px 42px 54px 42px;
				background-color: $p-color-blue-300;
				background-image: linear-gradient(-320deg, rgb(255, 255, 255, 0.1), rgb(255, 255, 255, 0.3));
			    background-position: center;
			    background-repeat: no-repeat;
			    background-size: auto 130%;
				border-radius: 3px 3px 0 0;


				font-size: 36px;
				font-style: normal;
				font-weight: 600;
				line-height: 36px;
				letter-spacing: 0.15px;	
				margin-top: 60px;			
				margin-bottom: 0;				
				color: $p-color-white;
				position: relative;
				overflow: hidden;				

				&::after{
					content: "";
				    display: block;
				    height: 100px;				    
				    position: absolute;
				    width: 110%;
				    left: -5%;
				    right: -5%;
				    bottom: -50px;
				    background-image: url(../../src/assets/design/organic-shapes/wave.svg);
				    background-repeat: no-repeat;
				    background-size: 100% 100%;
				    transition: all $p-transition-medium;
				}

				&:hover{

					text-decoration: underline;

					&::after{
						left: -10%;
						right: 0%;	
					}
				}

				&.green{
					background-color: $p-color-green-300;

					&::after{
						width: 120%;
						left: -10%;
						right: -10%;												
					}

					&:hover::after{
						width: 120%;
						left: -20%;
						right: 0%;							
					}
				}

				&.blue{
					background-color: $p-color-blue-300;

					&::after{
						width: 120%;
						left: -10%;
						right: -10%;
						transform:scaleX(-1);												
					}

					&:hover::after{
						width: 120%;
						left: 0%;
						right: -20%;							
					}
				}

				&.orange{
					background-color: $p-color-orange-300;

					&::after{
						width: 200%;
						left: -50%;
						right: -50%;																	
					}

					&:hover::after{
						width: 200%;
						left: -30%;
						right: -70%;							
					}

				}

			}

			.use-case-group-subtitle-experiment{
				display: block;
				text-decoration: none;

				width: 100%;
				min-height: 36px;
				text-align: left;
				box-sizing: border-box;
				padding: 0px 42px 24px 42px;
				background: $p-color-white;
				border-radius: 0 0 3px 3px;
				margin-bottom: 39px;
				color: $p-color-grey-600;				

				font-size: 18px;
				font-style: normal;
				font-weight: 500;
				line-height: 24px;
			}

			.use-case-tiles{
				display: flex; 	
				flex-wrap: wrap;
				justify-content: space-around;

				.use-case-tile{
					background: $p-color-white;
					padding: 24px 12px;
					min-width: 300px;
					max-width: 300px;
					min-height: 200px;
					max-height: 200px;
					margin: 42px 42px;
					border-radius: 3px;
					cursor: pointer;
					box-sizing: border-box;
					// border: 6px solid transparent;
					transition: border $p-transition-fast;
					display: flex;
				    flex-direction: column;
				    justify-content: space-between;
				    text-decoration: none;

				    box-shadow: 0px 0px $p-color-grey-400;
				    transition: all $p-transition-fast;
				    position: relative;
				    // border-top: 6px solid $p-color-grey-400;				   				   

				    @media screen and (max-width: 600px){
				    	margin: 24px;
				    	max-width: 100%;
				    	min-width: unset;
			    	    flex-grow: 1;
				    }

				    .tile-top-bar{
				    	position: absolute;
				    	top: 0;
				    	left: 0;
				    	height: 6px;
				    	width: 100%;
				    	border-radius: 3px 3px 0 0;
				    	background-color: $p-color-grey-400;
			    		background-image: linear-gradient(90deg, rgb(0, 0, 0, 0.2), rgb(255, 255, 255, 0.3));
			    	    background-position: center;
			    	    background-repeat: no-repeat;
			    	    background-size: auto 130%;

				    }

				    &.green{
				    	.tile-top-bar{
				    		background-color: $p-color-green-300;
				    	}
				    }

				    &.blue{
				    	.tile-top-bar{
				    		background-color: $p-color-blue-300;
				    	}
				    }

				    &.orange{
				    	.tile-top-bar{
				    		background-color: $p-color-orange-300;
				    	}
				    }

				    &:hover{
				    	@media(hover: hover) and (pointer: fine){
				    		transform: translate(6px, -6px);
				    	}
				    }

					.use-case-tile-title{						
						color: $p-color-grey-600;
						font-size: 24px;
						font-style: normal;
						font-weight: 600;
						line-height: 24px;
						letter-spacing: 0.15;
						text-align: left;
					}
					
					.app-icons{

						display: flex;
						flex-direction: row;

						.app-icon{
							
							min-height: 36px;
							min-width: 36px;
							border-radius: 3px;
							margin-right: 12px;
							display: flex;
							align-items: center;
							justify-content: center;

							&:hover{
								background: $p-color-grey-100;
							}

							.hover-tip{
								display: flex;
								align-items: center;
								justify-content: center;		
							}
						}
					}

					.tile-number{
						font-size: 14px;
						font-style: normal;
						font-weight: 600;
						line-height: 20px;
						color: $p-color-grey-400;
						text-align: right;						
						position: absolute;
						bottom: 24px;
						right: 18px;
					}
				}							
			}

			.group-expansion{
				cursor: pointer;
				margin-top: 30px;
				margin-right: 66px;

				text-align: right;				
				font-size: 14px;
				font-style: normal;
				font-weight: 600;
				line-height: 20px;
				letter-spacing: 0.15;
				text-align: right;
				color: $p-color-grey-200;

				@media screen and (max-width: 600px){
					margin-right: unset;
					text-align: center;
				}		
			}
		}								
	}

</style>
